export const environment = {
    stage: 'local',
    version: '2.15.3',
    baseUrl: 'http://localhost:8080',
    domain: 'dev-dehn-group.eu.auth0.com',
    clientId: 'ov8AZSY9raPsB4SzmhFcoterf0XglN6Y',
    redirect_uri: 'http://localhost:4200/callback'
};
